import { motion } from "framer-motion";
import { MessageCircle, Gauge, Fuel, Route } from "lucide-react";
import { engineWaLink } from "@/lib/wa";

const fmt = (n) => n?.toLocaleString("it-IT");

export default function EngineCard({ engine, index }) {
  const discount =
    engine.price_original && engine.price && engine.price_original > engine.price
      ? Math.round((1 - engine.price / engine.price_original) * 100)
      : null;

  return (
    <motion.article
      data-testid={`catalog-engine-card-${engine.sku}`}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.55, delay: (index % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
      className="group clip-card flex flex-col border border-[#272A38] bg-[#12141C] transition-colors duration-300 hover:border-[#F59E0B]/50 hover:bg-[#1A1D28]"
    >
      <div className="relative overflow-hidden bg-white">
        <img
          src={engine.photo}
          alt={engine.title}
          loading="lazy"
          className="spotlight-img h-52 w-full object-contain p-4"
        />
        <div className="absolute left-0 top-0 bg-[#0B0C10] px-3 py-1.5">
          <span className="mono text-[10px] font-bold uppercase tracking-widest text-[#F59E0B]">
            {engine.brand}
          </span>
        </div>
        {discount && (
          <div className="absolute right-0 top-0 bg-[#F59E0B] px-3 py-1.5">
            <span className="mono text-[10px] font-bold tracking-widest text-[#0B0C10]">
              -{discount}%
            </span>
          </div>
        )}
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#0B0C10]/25 to-transparent" />
      </div>

      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-display text-xl font-bold uppercase leading-tight text-[#F3F4F6]">
          {engine.title}
        </h3>
        <p className="mono mt-1 text-[11px] uppercase tracking-widest text-[#6B7280]">
          Cod. {engine.code} · {engine.engine_type}
        </p>

        <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-xs text-[#9CA3AF]">
          {engine.cv > 0 && (
            <span className="flex items-center gap-1.5">
              <Gauge className="h-3.5 w-3.5 text-[#F59E0B]" /> {engine.cv} CV
            </span>
          )}
          {engine.fuel && (
            <span className="flex items-center gap-1.5">
              <Fuel className="h-3.5 w-3.5 text-[#F59E0B]" /> {engine.fuel}
            </span>
          )}
          {engine.mileage > 0 && (
            <span className="flex items-center gap-1.5">
              <Route className="h-3.5 w-3.5 text-[#F59E0B]" /> {fmt(engine.mileage)} km
            </span>
          )}
        </div>

        <div className="mt-4 flex items-end justify-between border-t border-[#272A38] pt-4">
          <div>
            {engine.price_original && discount && (
              <div className="text-xs text-[#6B7280] line-through">
                € {fmt(engine.price_original)}
              </div>
            )}
            <div className="font-display text-3xl font-black text-[#F59E0B]" data-testid={`engine-price-${engine.sku}`}>
              {engine.price ? `€ ${fmt(engine.price)}` : "Su richiesta"}
            </div>
          </div>
          {engine.condition && (
            <span className="mono border border-[#272A38] px-2 py-1 text-[9px] uppercase tracking-widest text-[#9CA3AF]">
              {engine.condition}
            </span>
          )}
        </div>

        <a
          data-testid={`whatsapp-buy-button-${engine.sku}`}
          href={engineWaLink(engine)}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-5 flex items-center justify-center gap-2 bg-[#25D366] px-4 py-3 font-display text-base font-bold uppercase tracking-wide text-[#0B0C10] transition-colors duration-300 hover:bg-[#1EBE5B]"
        >
          <MessageCircle className="h-4 w-4" /> Richiedi su WhatsApp
        </a>
      </div>
    </motion.article>
  );
}
